import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import MainStageLayout from "./Layouts/MainStage/MainStageLayout";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { brown, red } from "@mui/material/colors";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchWhoAmI } from "./Store/Slices/InstallationSlice";
import { fetchServerEnv } from "./Store/Slices/DefsSlice";
import { loggedInUserInfoSliceActions } from "./Store/Slices/LoggedInUserInfo";

import Insight from "./Layouts/Insight";
import InsightAssignmentList from "./Layouts/Insight/InsightAssignmentList";
import InstallationLayout from "./Layouts/Installation/InstallationLayout";

import AssignLayout from "./Layouts/Dashboard/AssignLayout";
import AssignListLayout from "./Layouts/Dashboard/AssignListLayout";

import Assess from "./Layouts/Assess";
import AssessAssignmentList from "./Layouts/Assess/AssessAssignmentList";
import AssessAssetList from "./Layouts/Assess/AssessAssetList";
import AssessLearnerList from "./Layouts/Assess/AssessLearnerList";
import AssessAssetTypes from "./Layouts/Assess/AssessAssetTypes";

import StudentDashboard from "./Layouts/Dashboard/StudentDashboard";

import Login from "./Layouts/Login";
import Disclaimer from "./Layouts/Login/Disclaimer";
import Terms from "./Layouts/Login/Terms";
import PrivacyPolicy from "./Layouts/Login/PrivacyPolicy";
//import Podcast from "./Layouts/Login/Podcast";
import MonthlyReport from "./Layouts/Login/MonthlyReport";
import AITest from "./Layouts/Login/AITest";
import AITestData from "./Layouts/Login/AITestData";
import AITestReportView from "./Layouts/Login/AITestReportView";

import NewUserPasscodeValidate from "./Layouts/Login/NewUserPasscodeValidate";
import RecoverPassword from "./Layouts/Login/RecoverPassword";
import SetCredentials from "./Layouts/Login/SetCredentials";

import Teach from "./Layouts/Teach";
import TeachTreeView from "./Components/Course/TeachTreeView";
import Module from "./Layouts/Teach/Module";

import Root from "./Components/Course/Root";
import Intermediate from "./Components/Course/Intermediate";
import Leaf from "./Components/Course/Leaf";
import AssetSelect from "./Layouts/Task/AssetSelect";

import Task from "./Layouts/Task";
import TaskList from "./Layouts/Task/TaskList";
import TaskInfo from "./Layouts/Task/TaskInfo";
import TaskCreateEdit from "./Layouts/Task/TaskCreateEdit";
import TaskDetail from "./Layouts/Task/TaskDetail";

import Assign from "./Layouts/Assign";
import AssignList from "./Layouts/Assign/AssignList";
import AssignInfo from "./Layouts/Assign/AssignInfo";
import AssignCreateEdit from "./Layouts/Assign/AssignCreateEdit";

import Library from "./Layouts/Library";
import BookShelf from "./Layouts/Library/BookShelf";
import Book from "./Layouts/Library/Book";
import ReaderBoard from "./Layouts/Library/ReaderBoard";
import ReaderBoardCertificate from "./Layouts/Library/ReaderBoardCertificate";

import Assignment from "./Layouts/Assignment/Assignment";
import Rewards from "./Layouts/Rewards";
import Dashboard from "./Layouts/Dashboard";
import School from "./Layouts/SchoolManagement";
import CourseConfig from "./Layouts/SchoolManagement/CourseConfig";
import Report from "./Layouts/Report";

import Users from "./Layouts/Users";
import UserProfile from "./Layouts/Users/UserProfile";
import AssignTrainer from "./Layouts/Users/AssignTrainersClass";
import MoveLearners from "./Layouts/Users/MoveLearners";
import LearnersCertificates from "./Layouts/Users/LearnersCertificates";

import TypeOfReports from "./Layouts/Report/TypeOfReports";
import AssignmentsReport from "./Layouts/Report/Assignments";
import AssignmentStudentList from "./Layouts/Report/Assignments/AssignmentStudentList";
import LearnerAssetList from "./Layouts/Report/Assignments/LearnerAssetList";
import HeatmapList from "./Layouts/Report/Assignments/HeatmapList";
import AssignmentWiseSkills from "./Layouts/Report/Assignments/AssignmentWiseSkills";
import ProgressReport from "./Layouts/Report/Progress";
import ProgressInTrainerLogin from "./Layouts/Report/ProgressInTrainerLogin";

import TrainersReport from "./Layouts/Report/Trainers";
import LearnersReport from "./Layouts/Report/Learners";
import ClasswiseUsage from "./Layouts/Report/ClasswiseUsage";

import Profile from "./Layouts/Profile";
import Content from "./Layouts/Assets/Content";
import LicenseInfo from "./Layouts/LicenseInfo";

import PdfViewModal from "./Components/Modal/PdfViewModal";
import Channel from "./Layouts/Channel";
import ThirdParty from "./Layouts/ThirdParty";
import Error from "./Layouts/Error";

import Podcast from "./Layouts/Podcast";
import PodcastTabPanel from "./Layouts/Podcast/PodcastTab";
import PodcastList from "./Layouts/Podcast/PodcastList";
import PodcastInfo from "./Layouts/Podcast/PodcastInfo";
import CreatePodcast from "./Layouts/Podcast/CreatePodcast";
import PodcastRecording from "./Layouts/Podcast/PodcastRecording";
import PodcastRecordingEdit from "./Layouts/Podcast/PodcastRecordingEdit";

import Vocabulary from "./Layouts/Vocabulary";

import Feed from "./Layouts/Feed";

// Create theme and provide that theme from top most parent so that we can use it throughout app

const theme = createTheme({
  palette: {
    primary: {
      main: "#5f5600ff",
      error: red[500],
      success: "#86CC7D",
      subhead: "#c6c6c6",
      light: "#FFFFFF",
    },
    secondary: {
      main: red[800],
    },
    success: {
      main: "#86CC7D",
      contrastText: "#fff",
    },
    progress: {
      main: "#DB8829",
    },
    progresserror: {
      main: "#FF5562",
    },
    progresssuccess: {
      main: "#86CC7D",
    },
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
});

function App() {
  const dispatch = useDispatch();
  const accessToken = useSelector(
    (state) => state.loggedInUserInfo.accessToken
  );
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { loader } = useSelector((state) => state.common);
  const { whoAmIData } = useSelector((state) => state.installation);
  const { serverRole } = useSelector((state) => state.defs);

  // [useEffect] : Call 'fetchWhoAmI' from redux so that we can get whoami and route application accordingly

  useEffect(() => {
    dispatch(fetchWhoAmI());
    dispatch(
      fetchServerEnv({
        envName: "SERVER_ROLE",
      })
    );
    console.log("serverRole====", serverRole);
  }, [dispatch]);

  useEffect(() => {
    console.log("access", accessToken);
    console.log("serverRole=====>", serverRole);
    // let browser = getMobileOperatingSystem();
    // if (browser == "Android") {
    //   window.open(
    //     "https://play.google.com/store/apps/details?id=com.wordsworthelt.diamondclientapp&hl=en-IN"
    //   );
    // }
    // console.log("serverRole=====>", getMobileOperatingSystem());
    console.log("serverRole == '' || serverRole == 'WEB_HOST'");
  }, [serverRole]);

  // const getMobileOperatingSystem = () => {
  //   var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   console.log("serverRole=====>", userAgent);
  //   // Windows Phone must come first because its UA also contains "Android"
  //   if (/windows phone/i.test(userAgent)) {
  //     return "Windows Phone";
  //   }

  //   if (/android/i.test(userAgent)) {
  //     return "Android";
  //   }

  //   // iOS detection from: http://stackoverflow.com/a/9039885/177710
  //   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //     return "iOS";
  //   }
  //   return "unknown";
  // };

  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0,0,0,0.2)",
          }}
          open={loader}
        >
          <img src={require("./assets/cloudload.gif")} width={"10%"} />
        </Backdrop>
        <BrowserRouter>
          <Routes>
            {accessToken == null && (
              <>
                {serverRole != "" && serverRole != "WEB_HOST" && (
                  <>
                    <Route
                      path="/"
                      element={
                        whoAmIData.customer_uuid != null ? (
                          <Login />
                        ) : (
                          <Navigate to="/install" />
                        )
                      }
                    ></Route>
                    <Route
                      path="/install"
                      element={
                        whoAmIData.customer_uuid == null ? (
                          <InstallationLayout />
                        ) : (
                          <Navigate to="/" />
                        )
                      }
                    />
                  </>
                )}
                {serverRole == "" ||
                  (serverRole == "WEB_HOST" && (
                    <Route path="/" element={<Login />}></Route>
                  ))}

                <Route
                  path="NewUserPasscodeValidate"
                  element={<NewUserPasscodeValidate />}
                ></Route>
                <Route
                  path="RecoverPassword"
                  element={<RecoverPassword />}
                ></Route>

                <Route path="SetCredentials/:uid">
                  <Route path="" element={<SetCredentials />} />
                  <Route path=":paramusername" element={<SetCredentials />} />
                </Route>
                <Route path="Disclaimer" element={<Disclaimer />}></Route>
                <Route path="Terms" element={<Terms />}></Route>
                <Route path="PrivacyPolicy" element={<PrivacyPolicy />}></Route>
                <Route path="Podcast" element={<Podcast />}></Route>
                <Route
                  path="MonthlyReport/:siteuuid/:date?/:month/:year/:date2?/:month2?/:year2?"
                  element={<MonthlyReport />}
                ></Route>
                {/* <Route
                  path="MonthlyReport/:siteuuid/:date/:month/:year/:date2?/:month2?/:year2?"
                  element={<MonthlyReport />}
                ></Route> */}
                {process.env.REACT_APP_AI_OPEN == "true" && (
                  <>
                    <Route path="AITest" element={<AITest />}></Route>
                    <Route
                      path="AITestData/:pass"
                      element={<AITestData />}
                    ></Route>
                    <Route
                      path="AITestReportView"
                      element={<AITestReportView />}
                    ></Route>
                  </>
                )}
                {/* <Route
                  path="ThirdParty/:customerId/:appKey/:username/:appToken*"
                  element={<ThirdParty />}
                ></Route> */}
                <Route path="Error" element={<Error />}></Route>
              </>
            )}
            {/* <Route path="/"
            element={whoAmIData.customer_uuid != null ? <Login /> : <Navigate to="/install" />}>
          </Route>
          <Route path="disclimer" element={<Disclaimer />}></Route>
          <Route path="terms" element={<Terms_of_use />}></Route>
          <Route path="privacy" element={<Privacy_Policy />}></Route>
          <Route path="assigntrainersclass" element={<AssignTrainersClass />}></Route>
          <Route path="/install"
            element={whoAmIData.customer_uuid == null ? <InstallationLayout /> : <Navigate to="/" />} /> */}
            {accessToken != null && (
              <Route path="/" element={<MainStageLayout />}>
                <Route path="Profile" element={<Profile />}></Route>
                <Route path="LicenseInfo" element={<LicenseInfo />}></Route>
                <Route path="PdfViewModal" element={<PdfViewModal />}></Route>
                <>
                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "trainer" && (
                      <>
                        <Route path="Teach" element={<Teach />}>
                          <Route
                            path="TeachTreeView"
                            element={<TeachTreeView />}
                          ></Route>
                          <Route index element={<Module />}></Route>
                          <Route
                            path="Session/:id"
                            element={<Intermediate />}
                          ></Route>
                          <Route
                            path="Leaf/:moduleId/:id"
                            element={<Leaf />}
                          ></Route>
                          <Route path="Content">
                            <Route
                              path=":moduleId/:sessionId/:nodeId/:id"
                              element={<Content />}
                            />
                          </Route>
                        </Route>
                        <Route path="Task" element={<Task />}>
                          <Route index element={<TaskList />}></Route>
                          <Route path="Info/:id" element={<TaskInfo />}></Route>
                          <Route path="Create" element={<TaskCreateEdit />}>
                            <Route index element={<Root />}></Route>
                            <Route
                              path="Session/:id"
                              element={<Intermediate />}
                            ></Route>
                            <Route
                              path="Leaf/:moduleId/:id"
                              element={<Leaf />}
                            ></Route>
                            <Route
                              path="Asset/:moduleId/:sessionId/:nodeId/:id"
                              element={<AssetSelect />}
                            ></Route>
                            <Route
                              path="LibraryTask"
                              element={<BookShelf />}
                            ></Route>
                          </Route>
                          <Route
                            path="CreateDetail/:type"
                            element={<TaskDetail />}
                          ></Route>
                          <Route path="Edit" element={<TaskCreateEdit />}>
                            <Route index element={<Root />}></Route>
                            <Route
                              path="Session/:id"
                              element={<Intermediate />}
                            ></Route>
                            <Route
                              path="Leaf/:moduleId/:id"
                              element={<Leaf />}
                            ></Route>
                            <Route
                              path="Asset/:moduleId/:sessionId/:nodeId/:id"
                              element={<AssetSelect />}
                            ></Route>
                            <Route
                              path="LibraryTask"
                              element={<BookShelf />}
                            ></Route>
                          </Route>
                          <Route
                            path="EditDetail/:id/:type"
                            element={<TaskDetail />}
                          ></Route>
                          <Route path="AssetView">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>
                        <Route path="Assign" element={<Assign />}>
                          <Route index element={<AssignList />}></Route>
                          <Route
                            path="Info/:id"
                            element={<AssignInfo />}
                          ></Route>
                        </Route>
                        <Route path="Assign" element={<Assign />}>
                          <Route index element={<AssignList />}></Route>
                          <Route
                            path="Info/:id"
                            element={<AssignInfo />}
                          ></Route>
                          <Route
                            path="Create/:type"
                            element={<AssignCreateEdit />}
                          ></Route>
                          <Route
                            path="Edit/:id"
                            element={<AssignCreateEdit />}
                          ></Route>
                        </Route>

                        <Route path="assign" element={<AssignLayout />}></Route>
                        <Route
                          path="assignlist"
                          element={<AssignListLayout />}
                        ></Route>
                        <Route path="Assess" element={<Assess />}>
                          <Route
                            index
                            element={<AssessAssignmentList />}
                          ></Route>
                          <Route
                            path="AssetsList"
                            element={<AssessAssetList />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssessLearnerList />}
                          ></Route>
                          <Route
                            path="AssetTypes"
                            element={<AssessAssetTypes />}
                          ></Route>
                        </Route>

                        <Route path="Report" element={<Report />}>
                          <Route index element={<TypeOfReports />}></Route>
                          <Route
                            path="Assignments"
                            element={<AssignmentsReport />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssignmentStudentList />}
                          ></Route>
                          <Route
                            path="LearnerAssetList"
                            element={<LearnerAssetList />}
                          ></Route>
                          <Route
                            path="HeatmapList"
                            element={<HeatmapList />}
                          ></Route>
                          <Route
                            path="AssignmentWiseSkills"
                            element={<AssignmentWiseSkills />}
                          ></Route>
                          <Route
                            path="Trainers"
                            element={<TrainersReport />}
                          ></Route>
                          <Route
                            path="Learners"
                            element={<LearnersReport />}
                          ></Route>
                          <Route
                            path="ClasswiseUsage"
                            element={<ClasswiseUsage />}
                          ></Route>
                          <Route
                            path="Progress"
                            element={<ProgressReport />}
                          ></Route>
                          <Route path="Insight" element={<Insight />}></Route>
                          <Route
                            path="InsightAssignmentList"
                            element={<InsightAssignmentList />}
                          ></Route>
                          <Route path="LearnerContent">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>

                        <Route path="Library" element={<Library />}>
                          <Route index element={<BookShelf />}></Route>
                          <Route path="Book/:id" element={<Book />}></Route>
                          <Route
                            path="ReaderBoard"
                            element={<ReaderBoard />}
                          ></Route>
                        </Route>
                        <Route
                          path="studentdashboard"
                          element={<StudentDashboard />}
                        ></Route>
                        <Route path="Vocabulary" element={<Vocabulary />} />
                        <Route path="Feed" element={<Feed />} />
                      </>
                    )}
                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "learner" && (
                      <>
                        <Route
                          path="Assignment"
                          element={<Assignment />}
                        ></Route>
                        <Route
                          path="Assignment/Content/:assignmentId"
                          element={<Content />}
                        />
                        <Route
                          path="Assignment/Book/:assignmentId/:id"
                          element={<Book />}
                        />
                        <Route path="Rewards" element={<Rewards />}></Route>
                        <Route path="Report" element={<Report />}>
                          <Route index element={<TypeOfReports />}></Route>
                          <Route
                            path="Assignments"
                            element={<AssignmentsReport />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssignmentStudentList />}
                          ></Route>
                          <Route
                            path="LearnerAssetList"
                            element={<LearnerAssetList />}
                          ></Route>
                          <Route
                            path="Trainers"
                            element={<TrainersReport />}
                          ></Route>
                          <Route
                            path="Learners"
                            element={<LearnersReport />}
                          ></Route>
                          <Route
                            path="ClasswiseUsage"
                            element={<ClasswiseUsage />}
                          ></Route>
                          <Route
                            path="Progress"
                            element={<ProgressReport />}
                          ></Route>
                          <Route path="LearnerContent">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>

                        <Route path="Feed" element={<Feed />} />
                      </>
                    )}
                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "incharge" && (
                      <>
                        <Route path="Dashboard" element={<Dashboard />}></Route>
                        <Route path="Users" element={<Users />}></Route>
                        <Route
                          path="Users/UserInfo/"
                          element={<UserProfile />}
                        ></Route>
                        <Route
                          path="Users/Add/"
                          element={<UserProfile />}
                        ></Route>
                        <Route
                          path="Users/AssignTrainersClass"
                          element={<AssignTrainer />}
                        ></Route>
                        <Route
                          path="Users/LearnersCertificates"
                          element={<LearnersCertificates />}
                        ></Route>
                        <Route
                          path="Users/MoveLearners"
                          element={<MoveLearners />}
                        ></Route>
                        <Route path="School" element={<School />}></Route>
                        <Route
                          path="CourseConfig"
                          element={<CourseConfig />}
                        ></Route>
                        <Route path="Teach" element={<Teach />}>
                          <Route
                            path="TeachTreeView"
                            element={<TeachTreeView />}
                          ></Route>
                          <Route index element={<Module />}></Route>
                          <Route
                            path="Session/:id"
                            element={<Intermediate />}
                          ></Route>
                          <Route
                            path="Leaf/:moduleId/:id"
                            element={<Leaf />}
                          ></Route>
                          <Route path="Content">
                            <Route
                              path=":moduleId/:sessionId/:nodeId/:id"
                              element={<Content />}
                            />
                          </Route>
                        </Route>
                        <Route path="Report" element={<Report />}>
                          <Route index element={<TypeOfReports />}></Route>
                          <Route
                            path="Assignments"
                            element={<AssignmentsReport />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssignmentStudentList />}
                          ></Route>
                          <Route
                            path="LearnerAssetList"
                            element={<LearnerAssetList />}
                          ></Route>
                          <Route
                            path="HeatmapList"
                            element={<HeatmapList />}
                          ></Route>
                          <Route
                            path="AssignmentWiseSkills"
                            element={<AssignmentWiseSkills />}
                          ></Route>
                          <Route
                            path="Trainers"
                            element={<TrainersReport />}
                          ></Route>
                          <Route
                            path="Learners"
                            element={<LearnersReport />}
                          ></Route>
                          <Route
                            path="ClasswiseUsage"
                            element={<ClasswiseUsage />}
                          ></Route>
                          <Route
                            path="Progress"
                            element={<ProgressReport />}
                          ></Route>
                          <Route path="Insight" element={<Insight />}></Route>
                          <Route
                            path="InsightAssignmentList"
                            element={<InsightAssignmentList />}
                          ></Route>
                          <Route path="LearnerContent">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>
                        <Route path="Library" element={<Library />}>
                          <Route index element={<BookShelf />}></Route>
                          <Route path="Book/:id" element={<Book />}></Route>
                          <Route
                            path="ReaderBoard"
                            element={<ReaderBoard />}
                          ></Route>
                          <Route
                            path="ReaderBoardCertificate"
                            element={<ReaderBoardCertificate />}
                          ></Route>
                        </Route>
                        <Route path="Vocabulary" element={<Vocabulary />} />
                      </>
                    )}
                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "staff" && (
                      <>
                        <Route path="Teach" element={<Teach />}>
                          <Route index element={<Module />}></Route>
                          <Route
                            path="Session/:id"
                            element={<Intermediate />}
                          ></Route>
                          <Route
                            path="Leaf/:moduleId/:id"
                            element={<Leaf />}
                          ></Route>
                          <Route path="Content">
                            <Route
                              path=":moduleId/:sessionId/:nodeId/:id"
                              element={<Content />}
                            />
                          </Route>
                        </Route>
                        <Route path="Report" element={<Report />}>
                          <Route index element={<TypeOfReports />}></Route>
                          <Route
                            path="Assignments"
                            element={<AssignmentsReport />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssignmentStudentList />}
                          ></Route>
                          <Route
                            path="LearnerAssetList"
                            element={<LearnerAssetList />}
                          ></Route>
                          <Route
                            path="HeatmapList"
                            element={<HeatmapList />}
                          ></Route>
                          <Route
                            path="AssignmentWiseSkills"
                            element={<AssignmentWiseSkills />}
                          ></Route>
                          <Route
                            path="Trainers"
                            element={<TrainersReport />}
                          ></Route>
                          <Route
                            path="Learners"
                            element={<LearnersReport />}
                          ></Route>
                          <Route
                            path="ClasswiseUsage"
                            element={<ClasswiseUsage />}
                          ></Route>
                          <Route
                            path="Progress"
                            element={<ProgressReport />}
                          ></Route>
                          <Route path="Insight" element={<Insight />}></Route>
                          <Route
                            path="InsightAssignmentList"
                            element={<InsightAssignmentList />}
                          ></Route>
                          <Route path="LearnerContent">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>
                      </>
                    )}
                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "admin" && (
                      <>
                        <Route path="Dashboard" element={<Dashboard />}></Route>
                        <Route path="Users" element={<Users />}></Route>
                        <Route
                          path="Users/UserInfo/"
                          element={<UserProfile />}
                        ></Route>
                        <Route
                          path="Users/Add/"
                          element={<UserProfile />}
                        ></Route>
                        <Route
                          path="Users/AssignTrainersClass"
                          element={<AssignTrainer />}
                        ></Route>
                        <Route
                          path="Users/LearnersCertificates"
                          element={<LearnersCertificates />}
                        ></Route>
                        <Route
                          path="Users/MoveLearners"
                          element={<MoveLearners />}
                        ></Route>
                        <Route path="School" element={<School />}></Route>
                        <Route
                          path="CourseConfig"
                          element={<CourseConfig />}
                        ></Route>
                        <Route path="Teach" element={<Teach />}>
                          <Route index element={<Module />}></Route>
                          <Route
                            path="Session/:id"
                            element={<Intermediate />}
                          ></Route>
                          <Route
                            path="Leaf/:moduleId/:id"
                            element={<Leaf />}
                          ></Route>
                        </Route>
                        <Route path="Report" element={<Report />}>
                          <Route index element={<TypeOfReports />}></Route>
                          <Route
                            path="Assignments"
                            element={<AssignmentsReport />}
                          ></Route>
                          <Route
                            path="LearnerList"
                            element={<AssignmentStudentList />}
                          ></Route>
                          <Route
                            path="LearnerAssetList"
                            element={<LearnerAssetList />}
                          ></Route>
                          <Route
                            path="HeatmapList"
                            element={<HeatmapList />}
                          ></Route>
                          <Route
                            path="AssignmentWiseSkills"
                            element={<AssignmentWiseSkills />}
                          ></Route>
                          <Route
                            path="Trainers"
                            element={<TrainersReport />}
                          ></Route>
                          <Route
                            path="Learners"
                            element={<LearnersReport />}
                          ></Route>
                          <Route
                            path="ClasswiseUsage"
                            element={<ClasswiseUsage />}
                          ></Route>
                          <Route
                            path="Progress"
                            element={<ProgressReport />}
                          ></Route>
                          <Route path="Insight" element={<Insight />}></Route>
                          <Route
                            path="InsightAssignmentList"
                            element={<InsightAssignmentList />}
                          ></Route>
                          <Route path="LearnerContent">
                            <Route path=":id" element={<Content />} />
                          </Route>
                        </Route>
                        <Route path="Library" element={<Library />}>
                          <Route index element={<BookShelf />}></Route>
                          <Route path="Book/:id" element={<Book />}></Route>
                          <Route
                            path="ReaderBoard"
                            element={<ReaderBoard />}
                          ></Route>
                          <Route
                            path="ReaderBoardCertificate"
                            element={<ReaderBoardCertificate />}
                          ></Route>
                        </Route>
                      </>
                    )}

                  {userInfo &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title.toLowerCase() == "broadcast" && (
                      <>
                        <Route path="Podcast" element={<Podcast />}>
                          <Route index element={<PodcastTabPanel />}></Route>
                          <Route
                            path="Create"
                            element={<CreatePodcast />}
                          ></Route>
                          <Route
                            path="Info/:id"
                            element={<PodcastInfo />}
                          ></Route>
                          <Route
                            path="Recording/:id"
                            element={<PodcastRecording />}
                          ></Route>
                          <Route
                            path="RecordingEdit/:id"
                            element={<PodcastRecordingEdit />}
                          ></Route>
                        </Route>
                      </>
                    )}
                </>
              </Route>
            )}
            <Route
              path="*"
              element={
                <Navigate to="/" />
                // <Login />
              }
            />
          </Routes>
        </BrowserRouter>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}

export default App;
